<ng-container *ngIf="appState$ | async as appState">
  <div #header>
    <!-- HEADER -->
    <mat-toolbar
      color="primary"
      class="app-toolbar">
      <div class="max-page-container">
        <button
          *ngIf="appState.ui.mobileLayout"
          mat-icon-button
          (click)="handleToogleMenu(!appState.ui.hideSidebar)">
          <mat-icon
            aria-hidden="false"
            aria-label="sidebar icon">
            menu
          </mat-icon>
        </button>
        <a [routerLink]="['']">
          <img
            class="app-img-logo-right"
            [src]="'assets/img/web/nuevo_logo.svg'"
            alt="logo">
        </a>
        <!-- <span class="app-logo">{{logo}}</span>
  <span class="app-name">{{name}}</span> -->
        <span class="toolbar-spacer"></span>

        <div
          *ngIf="!appState.ui.mobileLayout"
          class="fuente-ubicacion"
          fxLayout="row"
          fxLayoutAlign="center center">

          <mat-icon
            class="location-icon-button m-r-5"
            matTooltip="¿Por qué ubicarme?"
            matTooltipPosition="above"
            (click)="handleOpenModalPorQueUbicarme()">
            help
          </mat-icon>
          <div
            class="location-icon-button  fuente-ubicacion"
            (click)="handleOpenModalCambiarUbicacion()">
            <span *ngIf="appState.globalConfig.userGeoLocation">Cambiar</span>
            <span *ngIf="!appState.globalConfig.userGeoLocation">Seleccionar Ubicación</span>
          </div>
        </div>

        <div
          *ngIf="!appState.ui.mobileLayout"
          class="fuente-ubicacion m-l-15 m-r-20"
          fxLayout="row"
          fxLayoutAlign="center center">
          <mat-icon class="location-icon-button m-r-5">location_on</mat-icon>
          <div *ngIf="appState.globalConfig.userGeoLocation">
            <span>{{appState.globalConfig.userGeoLocation.address}}</span>
          </div>

          <div *ngIf="!appState.globalConfig.userGeoLocation">
            <span>Ubicación no seleccionada</span>
          </div>

          <button
            class="fuente-ubicacion"
            *ngIf="appState.globalConfig.userGeoLocation"
            mat-icon-button
            type="button"
            matTooltip="Quitar ubicación"
            matTooltipPosition="above"
            (click)="handleRemoveUbicacion()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </mat-toolbar>
    <div class="mat-elevation-z{{appState.ui.stickyMenuElevation ? 8: 0}}">
      <ng-container *ngTemplateOutlet="tplMenuLg;"></ng-container>
    </div>
  </div>
  <!-- HEADER-END -->

  <!-- MAIN-CONTENT -->
  <mat-sidenav-container class="app-container">
    <mat-sidenav
      (click)="handleCloseSidenav()"
      class="app-sidebar"
      [opened]="!appState.ui.hideSidebar">
      <!-- <lib-menu
      [userInfo]="userInfo"
      [menu]="menu"></lib-menu> -->

      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/universidades']">
        Universidades
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/programas']">
        Programas
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/comunidad/estudiantes']">
        Comunidad estudiantil
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/comunidad/docentes']">
        Comunidad docentes
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/comparador/universidad']">
        Comparador
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/datos']">
        Base de datos
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/publicaciones']">
        Publicaciones
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        [routerLink]="['/about']">
        Nosotros
      </a>
      <!-- <a
        class="menu-item-vertical fullwidth"
        mat-button
        (click)="handleOpenModalCambiarUbicacion()">

        <span *ngIf="appState.globalConfig.userGeoLocation">Cambiar</span>
        <span *ngIf="!appState.globalConfig.userGeoLocation">Seleccionar Ubicación</span>

      </a> -->
      <a
        class="menu-item-vertical fullwidth wrap-text"
        mat-button
        (click)="handleOpenModalCambiarUbicacion()">
        <div *ngIf="appState.globalConfig.userGeoLocation">
          <span>{{appState.globalConfig.userGeoLocation.address}}</span>
        </div>

        <div *ngIf="!appState.globalConfig.userGeoLocation">
          <span>Ubicación no seleccionada</span>
        </div>
      </a>
      <a
        class="menu-item-vertical fullwidth"
        mat-button
        *ngIf="appState.globalConfig.userGeoLocation"
        (click)="handleRemoveUbicacion()">
        Quitar ubicación
        <mat-icon>delete</mat-icon>
      </a>
    </mat-sidenav>
    <mat-sidenav-content class="sidenav-content">
      <!-- TOOLBAR-USER-MENU -->
      <ng-container *ngTemplateOutlet="tplMenuLg;"></ng-container>
      <!-- TOOLBAR-USER-MENU-END -->
      <div class="main-content">

        <!-- <div>
        <div style="width:75%; margin: 0 auto;">
          <ng-content></ng-content>
        </div>
      </div> -->
        <ng-content></ng-content>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  <!-- MAIN-CONTENT-END -->
  <mat-menu #menuComunidad="matMenu">
    <button
      mat-menu-item
      [routerLink]="['/comunidad/estudiantes']">
      Comunidad estudiantil
    </button>
    <button
      mat-menu-item
      [routerLink]="['/comunidad/docentes']">
      Docentes
    </button>
  </mat-menu>

  <ng-template #tplMenuLg>
    <mat-toolbar
      class="app-sub-toolbar"
      *ngIf="!appState.ui.mobileLayout">
      <div class="max-page-container">
        <a
          class="menu-item-horizontal"
          mat-button
          [routerLink]="['/universidades']">
          Universidades
        </a>
        <a
          class="menu-item-horizontal"
          mat-button
          [routerLink]="['/programas']">
          Programas
        </a>
        <a
          class="menu-item-horizontal"
          mat-button
          [matMenuTriggerFor]="menuComunidad"
          #menuTrigger="matMenuTrigger"
          (mouseenter)="menuTrigger.openMenu()">
          Estadísticas
        </a>
        <a
          class="menu-item-horizontal"
          mat-button
          [routerLink]="['/comparador/universidad']">
          Comparador
        </a>
        <a
          class="menu-item-horizontal"
          mat-button
          [routerLink]="['/datos']">
          Base de datos
        </a>
        <a
          class="menu-item-horizontal"
          mat-button
          [routerLink]="['/publicaciones']">
          Publicaciones
        </a>
        <a
          class="menu-item-horizontal"
          mat-button
          [routerLink]="['/about']">
          Nosotros
        </a>
        <!-- <a
      class="menu-item-horizontal"
      mat-button
      [routerLink]="['/about']">
      Acerca de nosotros
    </a> -->
        <!-- <button
  mat-icon-button
  (click)="handleToogleMenu()">
  <mat-icon
    aria-hidden="false"
    aria-label="sidebar icon">
    menu
  </mat-icon>
</button> -->
        <span class="toolbar-spacer"></span>

        <!-- <button mat-icon-button>
  <mat-icon
    aria-hidden="false"
    aria-label="sidebar icon">
    account_circle
  </mat-icon>
</button> -->
      </div>
    </mat-toolbar>
  </ng-template>

</ng-container>
